import numeral from 'numeral';
import React, { Component } from 'react';

import './NewBankSelect.scss';

import If from '../../Shared/If/If';
import RadioButton from '../../Shared/RadioButton/RadioButton';
import { getFormattedBankName } from '../../../utils/utils';

export class NewBankSelect extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { bank, updateSelectedBank } = this.props;
    updateSelectedBank(bank);
  }

  render() {
    const { bank, bankIndex, selectedNewBank } = this.props;
    const { accountNumber, disable, ownerNames, value } = bank;
    const displayName = getFormattedBankName(bank);
    return (
      <label
        className={`blocked_data new-bank-select ${
          disable ? 'new-bank-select-disable' : ''
        }`}
      >
        <div>
          <RadioButton
            category="addBankSelection"
            accountNumber={accountNumber}
            checked={
              selectedNewBank && accountNumber === selectedNewBank.accountNumber
            }
            tabIndex={(bankIndex + 10).toString()}
            id={accountNumber}
            onClick={this.handleClick}
            disabled={disable}
            value={bank}
          />
          {displayName}{' '}
          <div className="new-bank-select-balance">
            {' '}
            — {numeral(value || 0).format('$0,0.00')}
          </div>
        </div>
        <If test={Array.isArray(ownerNames) && ownerNames.length}>
          <div className="new-bank-select-owner-names e2e-new-bank-owner-names">
            <span className="blocked_data text-nowrap">
              {ownerNames.join(', ')}
            </span>
          </div>
        </If>
      </label>
    );
  }
}

export default NewBankSelect;
